var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"header-policy"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/logo_atlas.svg"),"alt":"Meus pedidos"}})])],1),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }